import Gift from 'assets/img/gift.png';

import './UnopenedLootboxOverlayContent.styl';
import { observer } from 'mobx-react-lite';
import { useTranslationsContext } from 'store/translations';
import { Button } from 'components/core';
import { useNavigate } from 'react-router';
import { routes } from 'utils/router';
import { useStoreContext } from 'store/app';
import { IUnopenedLootbox } from 'src/types';

interface Props {
    lootbox: IUnopenedLootbox;
}

export const UnopenedLootboxOverlayContent = observer(({ lootbox }: Props) => {
    const { logOperation } = useStoreContext();
    const { translate } = useTranslationsContext();
    const navigate = useNavigate();

    return (
        <div className="unopened-gift">
            <img className="unopened-gift-image" src={Gift}></img>
            <div className="unopened-gift-title">{translate('unopened.lootbox.title')}</div>
            <div className="unopened-gift-desc">{translate('unopened.lootbox.desc')}</div>
            <Button
                onClick={() => {
                    logOperation('bonus_lootbox', 'open');
                    navigate(routes.lootbox, { state: { lootboxToOpen: lootbox.id } });
                }}
            >
                {translate('unopened.lootbox.button')}
            </Button>
        </div>
    );
});
